// extracted by mini-css-extract-plugin
export default {"bgNavbar":"Navbar_bgNavbar__88zo2"};